import { getUserInfo } from '../queries';

// function to fetch customer's personal details.
export const fetchCustomerDetails = async userMPID => {
  if (!userMPID) {
    throw new Error('Please provide a valid MPID.');
  }

  const response = await getUserInfo(userMPID);
  return response.data.getPatientDetails[0];
};
